export const DS_FEATURE_HINT_CLASSES = {
  Root: "ds-feature-hint",
  Media: "ds-feature-hint__media",
  MediaContent: "ds-feature-hint__media-content",
  Content: "ds-feature-hint__content",
  Header: "ds-feature-hint__header",
  Title: "ds-feature-hint__title",
  Text: "ds-feature-hint__text",
  Actions: "ds-feature-hint__actions",
  Spotlight: "ds-feature-hint-spotlight",
  SpotlightBackdrop: "ds-feature-hint-spotlight__backdrop",
} as const;
